import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["env", "version", "noGlobals"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SENTRY_DSN } from '../constants';
var DEFAULT_SENTRY_CONFIG = {
  whitelistUrls: [/atl-paas.net/,
  // test local host
  /localhost/],
  ignoreErrors: [/^SentryIgnore:/,
  // Network related errors
  'The operation was aborted', 'Software caused connection abort', 'GraphQL error: Failed to fetch', 'TypeError: Failed to fetch', 'TypeError: NetworkError when attempting to fetch resource.', 'AbortError: The user aborted a request.'],
  ignoreUrls: [
  // Chrome extensions
  /extensions\//i, /^chrome:\/\//i],
  dsn: SENTRY_DSN,
  attachStacktrace: true
};

// return value is an Sentry configuration object:
// https://docs.sentry.io/learn/configuration/?platform=javascript
export function getSentryConfig(options) {
  var env = options.env,
    version = options.version,
    _ = options.noGlobals,
    otherOptions = _objectWithoutProperties(options, _excluded);
  return _objectSpread(_objectSpread(_objectSpread({}, otherOptions), DEFAULT_SENTRY_CONFIG), {}, {
    // __VERSION__ is set from `bin/set-release-version.sh`
    // when building to deploy to production
    release: "".concat("@atlassian/teams-client", "@").concat("2.44.0") || '---',
    environment: env || 'prod'
  });
}